import React, { useState, useEffect } from 'react';
import 'primereact/resources/primereact.min.css';
import {
    calculateRouteWithId,
    calculateRouteWithWaypoints,
    getFuel
} from "../../../../utilidades/InegiEndpoints";
import './CotInegi.scss'
import {Card} from "primereact/card";
import {Panel} from "primereact/panel";
import {Button} from "primereact/button";
import {Message} from "primereact/message";
import {InputNumber} from "primereact/inputnumber";
import {Divider} from "primereact/divider";
import {ProgressSpinner} from "primereact/progressspinner";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import {desEncriptar} from "../../../../utilidades/encriptacion";
import Swal from 'sweetalert2';

const TransportQuoter = ({units, origin, destination, waypoints, providerOptions, setQuotations, daysCalc, donation}) => {
    const [selectedUnit, setSelectedUnit] = useState(null);
    const [passengers, setPassengers] = useState(20);
    const [days, setDays] = useState(daysCalc);
    const [distance, setDistance] = useState(null);
    const [fuelPrice, setFuelPrice] = useState(25.739);
    const [tollCost, setTollCost] = useState(null);
    const [operatorNightAllowance] = useState(500);
    const [operatorDailyExtra] = useState(500);
    const [utilityMargin, setUtilityMargin] = useState(30);
    const [operatorCommission] = useState(16);
    const [calculatingTolls, setCalculatingTolls] = useState(false);
    const [inegiTollCost, setInegiTollCost] = useState(null);
    const [routeError, setRouteError] = useState(null);
    const [quote, setQuote] = useState(null);
    const [extras, setExtras] = useState([]);

    // ===== NUEVOS ESTADOS PARA CÁLCULO DE PROVEEDOR =====
    const [providerCost, setProviderCost] = useState(0);
    const [providerUtility, setProviderUtility] = useState(15);
    const [providerQuote, setProviderQuote] = useState(null);

    const session = JSON.parse(
        desEncriptar(
            sessionStorage.getItem("dataClient"),
            process.env.REACT_APP_CLAVE_INCRIPTACION
        )
    );
    const userId = session?.user?.ID;

    // SERVICIOS EXTRAS
    const extrasCost = extras.reduce((total, extra) => {
        const price = parseFloat(extra.price) || 0;
        return total + price;
    }, 0);

    const [formCot, setFormCot] = useState({
        proveedor: null,
        pasajeros: 20,
        dias: 3,
    })


    useEffect(() => {
        setDays(daysCalc);
    }, [daysCalc]);

    const handleUnitSelect = (unit) => {
        setSelectedUnit(unit);
        setPassengers(getMaxCapacity(unit.caracteristicas));
        handleInputChangeCot('pasajeros', getMaxCapacity(unit.caracteristicas));
        setQuote(null);
        setDistance(null);
        setInegiTollCost(null);
        setTollCost(null);
    };

    const handleInputChangeCot = (field, value) => {
        setFormCot(prev => ({
            ...prev,
            [field]: value
        }));

        // Limpiar cálculos de proveedor si se deselecciona
        if (field === 'proveedor' && !value) {
            setProviderCost(0);
            setProviderQuote(null);
        }
    };

    /**
     * Redondea un número al múltiplo de 50 más cercano.
     * @param value Número a redondear
     */
    const roundTo50 = (value) => {
        return Math.round(value / 50) * 50;
    };

    /**
     * Extrae la capacidad máxima numérica de una unidad
     * @param characteristic - String con características de la unidad
     * @returns number - Capacidad máxima de pasajeros
     */
    const getMaxCapacity = (characteristic) => {
        if (!characteristic) return 0;

        // Buscar rango (ej: "45 A 50 PASAJEROS")
        const rango = characteristic.match(/(\d+)\s*A\s*(\d+)\s*PASAJEROS/i);
        if (rango) {
            return parseInt(rango[2], 10); // Retorna el límite superior
        }

        // Buscar número único (ej: "11 PASAJEROS")
        const unico = characteristic.match(/(\d+)\s*PASAJEROS/i);
        if (unico) {
            return parseInt(unico[1], 10);
        }

        return 0;
    };

    /**
     * Valida si el número de pasajeros excede la capacidad de la unidad
     * @returns boolean - true si es válido, false si excede capacidad
     */
    const validatePassengerCapacity = () => {
        if (!selectedUnit) {
            Swal.fire({
                icon: 'warning',
                title: 'Unidad no seleccionada',
                text: 'Por favor selecciona una unidad antes de agregar la cotización.',
                confirmButtonColor: '#3085d6'
            });
            return false;
        }

        const maxCapacity = getMaxCapacity(selectedUnit.caracteristicas);

        if (passengers > maxCapacity) {
            Swal.fire({
                icon: 'error',
                title: '¡Capacidad excedida!',
                html: `
                    <p>El número de pasajeros <strong>(${passengers})</strong> sobrepasa la capacidad máxima de la unidad <strong>${selectedUnit.name}</strong>.</p>
                    <p>Capacidad máxima: <strong>${maxCapacity} pasajeros</strong></p>
                `,
                confirmButtonColor: '#d33',
                confirmButtonText: 'Entendido'
            });
            return false;
        }

        return true;
    };



    const handleAddExtra = () => {
        setExtras(prev => [...prev, { name: '', price: 0 }]);
    };

    const handleExtraChange = (index, field, value) => {
        setExtras(prev => prev.map((extra, i) =>
            i === index ? { ...extra, [field]: value } : extra
        ));
    };

    const handleRemoveExtra = (index) => {
        setExtras(prev => prev.filter((_, i) => i !== index));
    };

    // ===== NUEVA FUNCIÓN: CÁLCULO DE COSTOS CON PROVEEDOR =====
    const calculateProviderQuote = (baseCost, utilityPercent) => {
        if (!baseCost || baseCost <= 0) return null;

        // Validar que el porcentaje de utilidad sea válido
        const validUtility = utilityPercent >= 0 && utilityPercent <= 100 ? utilityPercent : 0;

        // 1. Cálculo del IVA (16% sobre el costo base)
        const iva = baseCost * 0.16;
        const costWithIva = baseCost + iva;

        // 2. Cálculo de la utilidad (sobre el costo + IVA)
        const utilityAmount = costWithIva * (validUtility / 100);

        // 3. Costo final al cliente
        const final = costWithIva + utilityAmount;

        const finalCost = roundTo50(final);

        return {
            baseCost,
            iva,
            costWithIva,
            utilityPercent: validUtility,
            utilityAmount,
            finalCost,
            pricePerPerson: finalCost / passengers
        };
    };

    // ===== EFFECT: RECALCULAR CUANDO CAMBIAN PARÁMETROS DEL PROVEEDOR =====
    useEffect(() => {
        if (formCot.proveedor && providerCost > 0) {
            const newProviderQuote = calculateProviderQuote(providerCost, providerUtility);
            setProviderQuote(newProviderQuote);
        } else {
            setProviderQuote(null);
        }
    }, [providerCost, providerUtility, formCot.proveedor, passengers]);

    // Función para calcular cotización con parámetros específicos
    const calculateQuoteWithData = (unitData, distanceKm, tollCostTotal, passengersCount, daysCount, fuelPricePerLiter, extrasData, utilityMarginPercent) => {
        if (!unitData || !distanceKm) return null;

        // 1. COMBUSTIBLE - Cálculo mejorado
        const totalDistance = distanceKm * 2; // Ida y vuelta
        const fuelCost = (totalDistance / unitData.rendimiento) * fuelPricePerLiter;

        // 2. CASETAS - Directo del INEGI (ida y vuelta ya calculada)
        const totalTollCost = tollCostTotal || 0;

        // 3. VIÁTICOS DEL OPERADOR - Mejorado según especificaciones
        const nightsStayed = Math.max(0, daysCount - 1); // No cuenta el último día
        const operatorNightCost = nightsStayed * operatorNightAllowance;
        const maintenanceCost = totalDistance * unitData.factorCXK;
        const totalOperatorAllowance = operatorNightCost + maintenanceCost;

        // 4. FACTOR DE UNIDAD - Basado en costo diario de operación
        const unitOperationCost = unitData.factorD * daysCount;

        // SUBTOTAL (Costos directos)
        const subtotal = fuelCost + totalTollCost + totalOperatorAllowance + unitOperationCost + extrasCost;

        // 5. MARGEN DE UTILIDAD
        const utilityAmount = subtotal * (utilityMarginPercent / 100);
        const totalWithUtility = subtotal + utilityAmount;

        // 6. COMISIÓN DEL OPERADOR (16%) - Aplicado sobre el total con utilidad
        const commission = 1 -(operatorCommission / 100);
        const total = totalWithUtility / commission;

        // 7. IVA (16%) - Aplicado sobre el total
        const commissionAmount = (total * 0.16);
        const finalWithIva = total * (1 + 16 / 100);
        const finalTotal =  roundTo50(finalWithIva);
        const iva = total * 0.16;

        return {
            costs: {
                fuel: fuelCost,
                tolls: totalTollCost,
                operatorAllowance: {
                    nights: operatorNightCost,
                    daily: maintenanceCost,
                    total: totalOperatorAllowance
                },
                unitOperation: unitOperationCost,
                extras: extrasCost,
                subtotal: subtotal
            },
            calculations: {
                utilityAmount,
                totalWithUtility,
                commissionAmount,
                finalTotal,
                iva,
                pricePerPerson: finalTotal / passengersCount,
                totalDistance,
                nightsStayed
            }
        };
    };

    // Función para calcular ruta y costos con API INEGI
    const calculateRouteWithINEGI = async () => {
        if (!selectedUnit || !origin || !destination) return;

        setCalculatingTolls(true);
        setRouteError(null);
        setQuote(null);

        try {
            // Extraer IDs de waypoints
            const waypointIds = waypoints.map(wp => Number(wp.id_dest));

            // Calcular ruta con waypoints
            const routeData = waypoints.length > 0
                ? await calculateRouteWithWaypoints(
                    Number(origin.id_dest),
                    waypointIds,
                    Number(destination.id_dest),
                    selectedUnit.tipo
                )
                : await calculateRouteWithId(
                    Number(origin.id_dest),
                    Number(destination.id_dest),
                    selectedUnit.tipo
                );

            const fuel = await getFuel(selectedUnit.combustible);
            setFuelPrice(fuel);

            const newDistance = Math.round(routeData.distancia_km);
            const newInegiTollCost = routeData.costo_caseta || 0;
            const newTotalTollCost = newInegiTollCost * 2; // Ida y vuelta

            // Actualizar estados
            setDistance(newDistance);
            setInegiTollCost(newInegiTollCost);
            setTollCost(newTotalTollCost);
            setRouteError(null);

            // Calcular cotización
            const calculatedQuote = calculateQuoteWithData(
                selectedUnit,
                newDistance,
                newTotalTollCost,
                passengers,
                days,
                fuelPrice,
                extras,
                utilityMargin
            );

            setQuote(calculatedQuote);

        } catch (error) {
            console.error('Error con API INEGI:', error);
            setRouteError(error.message);
        } finally {
            setCalculatingTolls(false);
        }
    };

    // Effect para recalcular cuando cambian parámetros (después de tener datos de INEGI)
    useEffect(() => {
        if (selectedUnit && distance && tollCost !== null) {
            const newQuote = calculateQuoteWithData(
                selectedUnit,
                distance,
                tollCost,
                passengers,
                days,
                fuelPrice,
                extras,
                utilityMargin
            );
            setQuote(newQuote);
        }
    }, [passengers, days, fuelPrice, utilityMargin, extras, distance, tollCost]);

    const addCot = async () => {
        // Validar capacidad antes de agregar
        if (!validatePassengerCapacity()) {
            return; // Detener ejecución si no pasa la validación
        }

        if (!quote) {
            Swal.fire({
                icon: 'warning',
                title: 'Cotización incompleta',
                text: 'Por favor calcula la ruta y genera la cotización antes de agregar.',
                confirmButtonColor: '#3085d6'
            });
            return;
        }

        const cotizacion = {
            ...formCot,
            unidad: selectedUnit?.code,
            picture: selectedUnit?.foto,
            unidadNombre: selectedUnit?.name,
            precio: quote.calculations.finalTotal,
            movimientos: 20,
            casetas: tollCost,
            combustible: quote.costs.fuel,
            variables: quote.costs.operatorAllowance.daily,
            chofer: quote.calculations.commissionAmount,
            hotel: quote.costs.operatorAllowance.nights,
            costoOperacion: quote.costs.unitOperation,
            costoProveedor: providerCost || 0,
            utilidadProveedor: providerUtility || 0,
            ivaProveedor: providerQuote?.iva || 0,
            donacion: donation
        };

        setQuotations((prev) => [...prev, cotizacion]);
    };

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('es-MX', {
            style: 'currency',
            currency: 'MXN'
        }).format(amount);
    };

    const getPasajeros= (characteristic) => {
        if (!characteristic) return "N/D";

        const rango = characteristic.match(/(\d+)\s*A\s*(\d+)\s*PASAJEROS/i);
        if (rango) {
            return `${parseInt(rango[1], 10)} - ${parseInt(rango[2], 10)}`;
        }

        const unico = characteristic.match(/(\d+)\s*PASAJEROS/i);
        if (unico) {
            return `${parseInt(unico[1], 10)}`;
        }

        return "N/D";
    }


    return (
        <div className="transport-quote">
            <div className="transport-quote__content">
                {/* Panel de Configuración */}
                <Card className="transport-quote__config" title="Configuración del Viaje">
                    {/* Selección de Unidad */}
                    <div className="transport-quote__units">
                        <label className="transport-quote__label">Seleccionar Unidad:</label>
                        <div className="transport-quote__units-grid">
                            {units.map(unit => (
                                <div
                                    key={unit.code}
                                    onClick={() => handleUnitSelect(unit)}
                                    className={`transport-quote__unit ${
                                        selectedUnit?.code === unit.code ? 'transport-quote__unit--selected' : ''
                                    }`}
                                >
                                    <div className="transport-quote__unit-content">
                                        <i className="pi pi-car" />
                                        <div className="transport-quote__unit-info">
                                            <div className="transport-quote__unit-name">{unit.name}</div>
                                            <div className="transport-quote__unit-details">
                                                Capacidad: {getPasajeros(unit?.caracteristicas)} pasajeros
                                                <br/>
                                                Rendimiento: {unit.rendimiento} km/l
                                                <br />
                                                Costo operación: {formatCurrency(unit.factorD)}/día
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Configuración de Ruta con API INEGI */}
                    <Panel className="transport-quote__route-config" header="Configuración de Ruta (API INEGI)">
                        <Button
                            onClick={calculateRouteWithINEGI}
                            disabled={calculatingTolls || !selectedUnit || !origin?.lat || !destination?.lat}
                            className="transport-quote__calc-button"
                            icon={calculatingTolls ? <ProgressSpinner style={{ width: '20px', height: '20px' }} /> : "pi pi-calculator"}
                            label={calculatingTolls ? "Calculando con INEGI..." : "Calcular Ruta y Casetas"}
                        />

                        {routeError && (
                            <Message severity="error" text={`Error: ${routeError}`} />
                        )}

                        {inegiTollCost !== null && (
                            <Message severity="success" text={`✓ Datos actualizados desde INEGI: ${distance} km, casetas: ${formatCurrency(inegiTollCost)} (ida y vuelta: ${formatCurrency(tollCost)})`} />
                        )}
                    </Panel>

                    {/* Parámetros del Viaje */}
                    <div className="transport-quote__params">
                        <div className="p-field">
                            <label htmlFor="passengers">
                                <i className="pi pi-user" />
                                Pasajeros
                                {selectedUnit && (
                                    <span style={{
                                        marginLeft: '8px',
                                        fontSize: '0.85em',
                                        color: passengers > getMaxCapacity(selectedUnit.caracteristicas) ? '#e74c3c' : '#27ae60'
                                    }}>
                                        (Max: {getMaxCapacity(selectedUnit.caracteristicas)})
                                    </span>
                                )}
                            </label>
                            <InputNumber
                                id="passengers"
                                value={passengers}
                                onValueChange={(e) => {
                                    setPassengers(e.value);
                                    handleInputChangeCot('pasajeros', e.value);
                                }}
                                min={1}
                                max={selectedUnit ? getMaxCapacity(selectedUnit.caracteristicas) : 50}
                                className={
                                    selectedUnit && passengers > getMaxCapacity(selectedUnit.caracteristicas)
                                        ? 'p-invalid'
                                        : ''
                                }
                            />
                            {selectedUnit && passengers > getMaxCapacity(selectedUnit.caracteristicas) && (
                                <small className="p-error" style={{ display: 'block', marginTop: '4px' }}>
                                    ⚠️ La capacidad máxima es {getMaxCapacity(selectedUnit.caracteristicas)} pasajeros
                                </small>
                            )}
                        </div>

                        <div className="p-field">
                            <label htmlFor="days">
                                <i className="pi pi-calendar" />
                                Días
                            </label>
                            <InputNumber
                                id="days"
                                value={days}
                                onValueChange={(e) => {
                                    setDays(e.value);
                                    handleInputChangeCot('dias', e.value);
                                }}
                                min={1}
                            />
                        </div>
                    </div>

                    {/* Costos Base */}
                    <div className="transport-quote__costs">
                        <div className="p-field">
                            <label htmlFor="fuelPrice">Precio Combustible ($/L)</label>
                            <InputNumber
                                id="fuelPrice"
                                value={fuelPrice}
                                onValueChange={(e) => setFuelPrice(e.value)}
                                minFractionDigits={1}
                                maxFractionDigits={2}
                            />
                        </div>

                        <div className="p-field">
                            <label htmlFor="distance">
                                Distancia (km)
                                {inegiTollCost !== null && <span className="transport-quote__inegi-label">• Calculada por INEGI</span>}
                            </label>
                            <InputNumber
                                id="distance"
                                value={distance}
                                onValueChange={(e) => setDistance(e.value)}
                                className={inegiTollCost !== null ? 'transport-quote__inegi-input' : ''}
                                disabled={inegiTollCost !== null}
                            />
                        </div>

                        <div className="p-field">
                            <label htmlFor="tollCost">
                                Casetas Totales ($)
                                {inegiTollCost !== null && <span className="transport-quote__inegi-label">• Calculadas por INEGI</span>}
                            </label>
                            <InputNumber
                                id="tollCost"
                                value={tollCost}
                                onValueChange={(e) => setTollCost(e.value)}
                                className={inegiTollCost !== null ? 'transport-quote__inegi-input' : ''}
                                disabled={inegiTollCost !== null}
                            />
                        </div>

                        <div className="p-field">
                            <label htmlFor="utilityMargin">Margen Utilidad (%)</label>
                            <InputNumber
                                id="utilityMargin"
                                value={utilityMargin}
                                onValueChange={(e) => setUtilityMargin(e.value)}
                                min={userId === 4988 ? 0 : 15}
                            />
                        </div>

                        <div className="p-field">
                            <label htmlFor="operatorCommission">Comisión Operador (%)</label>
                            <InputNumber
                                id="operatorCommission"
                                value={operatorCommission}
                                disabled
                            />
                        </div>

                        <div className="p-field">
                            <label htmlFor="provider">Proveedor</label>
                            <Dropdown
                                id="provider"
                                value={providerOptions.find(prov => prov.code === formCot.proveedor?.code)}
                                options={providerOptions}
                                optionLabel="name"
                                placeholder="Selecciona proveedor"
                                onChange={(e) => handleInputChangeCot('proveedor', e.value)}
                                style={{width: '100%'}}
                            />
                        </div>
                    </div>

                    {formCot.proveedor && (
                        <Panel
                            header="💰 Cálculo con Proveedor"
                            className="transport-quote__provider-section"
                            toggleable
                        >
                            <Message
                                severity="info"
                                text="Ingresa el costo base proporcionado por el proveedor para calcular automáticamente el precio final con IVA y utilidad."
                            />

                            <div className="transport-quote__provider-inputs">
                                <div className="p-field">
                                    <label htmlFor="providerCost">
                                        <i className="pi pi-dollar" />
                                        Costo Base del Proveedor
                                    </label>
                                    <InputNumber
                                        id="providerCost"
                                        value={providerCost}
                                        onValueChange={(e) => setProviderCost(e.value || 0)}
                                        mode="currency"
                                        currency="MXN"
                                        locale="es-MX"
                                        minFractionDigits={2}
                                        min={0}
                                        placeholder="Ingresa el costo del proveedor"
                                    />
                                </div>

                                <div className="p-field">
                                    <label htmlFor="providerUtility">
                                        <i className="pi pi-percentage" />
                                        Utilidad (%)
                                    </label>
                                    <InputNumber
                                        id="providerUtility"
                                        value={providerUtility}
                                        onValueChange={(e) => setProviderUtility(e.value || 0)}
                                        min={0}
                                        max={100}
                                        suffix="%"
                                    />
                                </div>
                            </div>

                            {/* Desglose de Cálculos con Proveedor */}
                            {providerQuote && (
                                <div className="transport-quote__provider-breakdown">
                                    <Divider />
                                    <h4>📊 Desglose de Costos</h4>

                                    <div className="transport-quote__cost-item">
                                        <span>Costo Base Proveedor</span>
                                        <span className="transport-quote__amount">{formatCurrency(providerQuote.baseCost)}</span>
                                    </div>

                                    <div className="transport-quote__cost-item transport-quote__cost-item--info">
                                        <span>+ IVA (16%)</span>
                                        <span className="transport-quote__amount">{formatCurrency(providerQuote.iva)}</span>
                                    </div>

                                    <div className="transport-quote__cost-item">
                                        <span>= Subtotal con IVA</span>
                                        <span className="transport-quote__amount transport-quote__amount--bold">
                                            {formatCurrency(providerQuote.costWithIva)}
                                        </span>
                                    </div>

                                    <Divider />

                                    <div className="transport-quote__cost-item transport-quote__cost-item--positive">
                                        <span>+ Utilidad ({providerQuote.utilityPercent}%)</span>
                                        <span className="transport-quote__amount">{formatCurrency(providerQuote.utilityAmount)}</span>
                                    </div>

                                    <Divider />

                                    <div className="transport-quote__cost-item transport-quote__cost-item--total">
                                        <span>TOTAL FINAL AL CLIENTE</span>
                                        <span className="transport-quote__amount transport-quote__amount--large">
                                            {formatCurrency(providerQuote.finalCost)}
                                        </span>
                                    </div>

                                    <div className="transport-quote__cost-item">
                                        <span>Precio por Persona ({passengers} pax)</span>
                                        <span className="transport-quote__amount">
                                            {formatCurrency(providerQuote.pricePerPerson)}
                                        </span>
                                    </div>
                                </div>
                            )}
                        </Panel>
                    )}

                    {/* SERVICIOS EXTRAS */}
                    <Panel header="Servicios Adicionales">
                        <div className="extras-section">
                            {extras.map((extra, index) => (
                                <div key={index} className="extra-item">
                                    <div className="p-field">
                                        <label htmlFor={`extra-name-${index}`}>Nombre del servicio</label>
                                        <InputText
                                            id={`extra-name-${index}`}
                                            value={extra.name}
                                            onChange={(e) => handleExtraChange(index, 'name', e.target.value)}
                                            placeholder="Ej: Guía turístico"
                                            style={{ width: '100%' }}
                                        />
                                    </div>

                                    <div className="p-field">
                                        <label htmlFor={`extra-price-${index}`}>Precio</label>
                                        <InputNumber
                                            id={`extra-price-${index}`}
                                            value={extra.price}
                                            onValueChange={(e) => handleExtraChange(index, 'price', e.value)}
                                            mode="currency"
                                            currency="MXN"
                                            locale="es-MX"
                                            minFractionDigits={2}
                                            style={{ width: '100%' }}
                                        />
                                    </div>

                                    <Button
                                        icon="pi pi-trash"
                                        className="p-button-danger p-button-text extra-remove-btn"
                                        onClick={() => handleRemoveExtra(index)}
                                        tooltip="Eliminar servicio"
                                        tooltipOptions={{ position: 'top' }}
                                    />
                                </div>
                            ))}

                            <Button
                                icon="pi pi-plus"
                                label="Agregar Servicio Extra"
                                className="p-button-success p-button-outlined"
                                onClick={handleAddExtra}
                                style={{ width: '100%', marginTop: '1rem' }}
                            />

                            {extras.length > 0 && (
                                <Divider />
                            )}

                            <div className="extras-total">
                                <strong>Total Extras: {formatCurrency(extrasCost)}</strong>
                            </div>
                        </div>
                    </Panel>
                    <Button
                        onClick={() => addCot()}
                        style={{marginTop: '3rem'}}
                        className="transport-quote__calc-button"
                        icon={calculatingTolls ? <ProgressSpinner style={{ width: '20px', height: '20px' }} /> : "pi pi-calculator"}
                        label={calculatingTolls ? "Agregando Cotización..." : "Agregar Cotización"}/>
                </Card>

                {/* Panel de Cotización */}
                <Card className="transport-quote__quote" title={
                    <>
                        <i className="pi pi-file" />
                        Cotización Detallada
                    </>
                }>
                    {selectedUnit && quote ? (
                        <div className="transport-quote__quote-content">
                            {/* Información de la Unidad */}
                            <Panel className="transport-quote__unit-info-panel caracteristicas-card" header={selectedUnit.name}>
                                <div className="caracteristicas-card">
                                    <div className="bus-image">
                                        <img src={selectedUnit.foto} alt="Autobús" />
                                    </div>
                                    <div className="caracteristicas-content">
                                        <h3>Características Unidad</h3>
                                        <div className="caracteristicas-list">
                                            {selectedUnit.caracteristicas
                                                ?.split(';')
                                                .filter((c) => c.trim() !== "")
                                                .map((caracteristica, i) => (
                                                    <div key={i} className="caracteristica-item">
                                                        <i className="pi pi-check-circle"></i>
                                                        <span>{caracteristica}</span>
                                                    </div>
                                                ))}
                                        </div>
                                    </div>
                                </div>
                            </Panel>

                            {/* Desglose de Costos */}
                            <div className="transport-quote__breakdown">
                                <Panel header="COSTOS DIRECTOS">
                                    <div className="transport-quote__cost-item">
                                        <span>Combustible ({quote.calculations.totalDistance} km ÷ {selectedUnit.rendimiento} km/l)</span>
                                        <span>{formatCurrency(quote.costs.fuel)}</span>
                                    </div>
                                    <div className="transport-quote__cost-item">
                                        <span>Casetas/Peajes (Ida y vuelta)</span>
                                        <span>{formatCurrency(quote.costs.tolls)}</span>
                                    </div>
                                    <div className="transport-quote__cost-item">
                                        <span>Viáticos Operador:</span>
                                        <span></span>
                                    </div>
                                    <div className="transport-quote__cost-item transport-quote__cost-subitem">
                                        <span>• Hospedaje ({quote.calculations.nightsStayed} noches × $500)</span>
                                        <span>{formatCurrency(quote.costs.operatorAllowance.nights)}</span>
                                    </div>
                                    <div className="transport-quote__cost-item transport-quote__cost-subitem">
                                        <span>• Costo Mantenimiento (km × factor CxK)</span>
                                        <span>{formatCurrency(quote.costs.operatorAllowance.daily)}</span>
                                    </div>
                                    <div className="transport-quote__cost-item">
                                        <span>Operación de Unidad ({days} días)</span>
                                        <span>{formatCurrency(quote.costs.unitOperation)}</span>
                                    </div>
                                    {quote.costs.extras > 0 && (
                                        <div className="transport-quote__cost-item">
                                            <span>Servicios Extras</span>
                                            <span>{formatCurrency(quote.costs.extras)}</span>
                                        </div>
                                    )}
                                    <Divider />
                                    <div className="transport-quote__cost-item transport-quote__cost-item--total">
                                        <span>SUBTOTAL</span>
                                        <span>{formatCurrency(quote.costs.subtotal)}</span>
                                    </div>
                                </Panel>

                                <Panel header="MÁRGENES Y COMISIONES">
                                    <div className="transport-quote__cost-item transport-quote__cost-item--positive">
                                        <span>Margen de Utilidad ({utilityMargin}%)</span>
                                        <span>{formatCurrency(quote.calculations.utilityAmount)}</span>
                                    </div>
                                    <div className="transport-quote__cost-item transport-quote__cost-item--warning">
                                        <span>Total con Utilidad</span>
                                        <span>{formatCurrency(quote.calculations.totalWithUtility)}</span>
                                    </div>
                                    <div className="transport-quote__cost-item transport-quote__cost-item--info">
                                        <span>Comisión Operador ({operatorCommission}%)</span>
                                        <span>{formatCurrency(quote.calculations.commissionAmount)}</span>
                                    </div>
                                </Panel>

                                <div className="transport-quote__total">
                                    <div className="transport-quote__total-amount">
                                        <span>TOTAL GENERAL CON IVA</span>
                                        <span>{formatCurrency(quote.calculations.finalTotal)}</span>
                                    </div>
                                    <div className="transport-quote__per-person">
                                        <span>IVA (16%)</span>
                                        <span>{formatCurrency(quote.calculations.iva)}</span>
                                    </div>
                                    <div className="transport-quote__per-person">
                                        <span>Precio por persona ({passengers} pax)</span>
                                        <span>{formatCurrency(quote.calculations.pricePerPerson)}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="transport-quote__empty">
                            <i className="pi pi-car" />
                            <p>
                                {!selectedUnit
                                    ? 'Selecciona una unidad para generar la cotización'
                                    : 'Presiona "Calcular Ruta y Casetas" para obtener la cotización'
                                }
                            </p>
                        </div>
                    )}
                </Card>
            </div>

            {/* Resumen Final */}
            {selectedUnit && quote && (
                <Card className="transport-quote__summary" title="Resumen Ejecutivo">
                    <div className="transport-quote__summary-grid">
                        <div className="transport-quote__summary-item transport-quote__summary-item--blue">
                            <div className="transport-quote__summary-value">{passengers}</div>
                            <div className="transport-quote__summary-label">Pasajeros</div>
                        </div>
                        <div className="transport-quote__summary-item transport-quote__summary-item--green">
                            <div className="transport-quote__summary-value">{quote.calculations.totalDistance} km</div>
                            <div className="transport-quote__summary-label">Distancia Total</div>
                        </div>
                        <div className="transport-quote__summary-item transport-quote__summary-item--purple">
                            <div className="transport-quote__summary-value">{days}</div>
                            <div className="transport-quote__summary-label">Días</div>
                        </div>
                        <div className="transport-quote__summary-item transport-quote__summary-item--orange">
                            <div className="transport-quote__summary-value">{formatCurrency(quote.calculations.pricePerPerson)}</div>
                            <div className="transport-quote__summary-label">Por Persona</div>
                        </div>
                    </div>
                </Card>
            )}
        </div>
    );
};

export default TransportQuoter;